import React, {useState} from "react";
import {Link} from "react-router-dom";
import DonationModal from "./DonationModel";
import logo from "../assets/chicalac.png"

export default function Navbar() {
    const [mobileOpen, setMobileOpen] = useState(false);
    const [donationOpen, setDonationOpen] = useState(false);

    return (
        <>
            <nav className="py-6 bg-transparent border-b border-gray-100">
                <div className="container mx-auto px-4 flex items-center justify-between">
                    {/* Logo */}
                    <Link to="/" className="flex items-center space-x-2 text-lg font-bold text-gray-900">
                        <img loading="lazy"  src={logo} alt="CHICALAC Logo" className="h-10 w-auto" />
                        <span className="text-xl font-semibold text-orange-900">CHICALAC</span>
                    </Link>

                    {/* Desktop Links */}
                    <ul className="hidden lg:flex space-x-8 items-center">
                        <li>
                            <Link to="/" className="text-sm font-medium text-gray-900 hover:text-orange-900">
                                Home
                            </Link>
                        </li>
                        <li>
                            <Link to="/aboutus" className="text-sm font-medium text-gray-900 hover:text-orange-900">
                                About
                            </Link>
                        </li>
                        <li>
                            <Link to="/contact" className="text-sm font-medium text-gray-900 hover:text-orange-900">
                                Contact
                            </Link>
                        </li>
                        <li>
                            <Link to="/news" className="text-sm font-medium text-gray-900 hover:text-orange-900">
                                News
                            </Link>
                        </li>
                        

                    </ul>

                    {/* CTA and Hamburger */}
                    <div className="flex items-center lg:space-x-6">

                        <button
                            onClick={() => setDonationOpen(true)}
                            className="hidden lg:inline-block relative group py-3 px-4 text-sm font-semibold text-white bg-orange-900 hover:bg-gray-900 border border-orange-900 rounded-md overflow-hidden transition duration-300"
                        >
                            <span className="relative">Donate</span>
                        </button>

                        {/* Mobile menu toggle */}
                        <button
                            onClick={() => setMobileOpen(!mobileOpen)}
                            className="lg:hidden text-gray-900 hover:text-orange-900 focus:outline-none"
                        >
                            <svg
                                className="w-6 h-6"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                viewBox="0 0 24 24"
                            >
                                {mobileOpen ? (
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M6 18L18 6M6 6l12 12"
                                    />
                                ) : (
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M4 6h16M4 12h16M4 18h16"
                                    />
                                )}
                            </svg>
                        </button>
                    </div>
                </div>

                {/* Mobile Dropdown Menu */}
                {mobileOpen && (
                    <div className="lg:hidden px-4 pt-4 pb-6 space-y-3 bg-white shadow-md">
                        <Link to="/" className="block text-sm font-medium text-gray-700 hover:text-orange-900">
                            Home
                        </Link>
                        <Link to="/aboutus" className="block text-sm font-medium text-gray-700 hover:text-orange-900">
                            About
                        </Link>
                        <Link to="/contact" className="block text-sm font-medium text-gray-700 hover:text-orange-900">
                            Contact
                        </Link>
                        <Link to="/news" className="block text-sm font-medium text-gray-700 hover:text-orange-900">
                            News
                        </Link>

                        <Link to="/contact" className="block text-sm font-semibold text-orange-900 hover:text-gray-900">
                            Get Help
                        </Link>
                        <button
                            onClick={() => {
                                setDonationOpen(true);
                                setMobileOpen(false);
                            }}
                            className="w-full text-sm font-semibold text-white bg-orange-900 hover:bg-gray-900 py-3 rounded-md"
                        >
                            Donate
                        </button>
                    </div>
                )}
            </nav>

            {/* Donation Modal */}
            <DonationModal open={donationOpen} onClose={() => setDonationOpen(false)} />
        </>
    );
}
